"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GOOGLE = exports.FACEBOOK = void 0;
exports.FACEBOOK = "facebook";
exports.GOOGLE = "google";